import { render, staticRenderFns } from "./QuizEventMaker.vue?vue&type=template&id=5811d5dc&scoped=true&"
import script from "./QuizEventMaker.vue?vue&type=script&lang=ts&"
export * from "./QuizEventMaker.vue?vue&type=script&lang=ts&"
import style0 from "./QuizEventMaker.vue?vue&type=style&index=0&id=5811d5dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5811d5dc",
  null
  
)

export default component.exports